<div class="button-container">
    @if (!icon && !isMenuItem && !menu) {
        <button mat-button
                [color]="color"
                type="submit"
                (cbClick)="onClick($event)"
                [clickLimit]="clickLimit"
                [ngClass]="{
              'mat-stroked-button': isStroked,
              'mat-raised-button': !isStroked,
              'disabled-button': disabled$ | async,
              'white-button-border': color === 'white'
          }"
                [disabled]="disabled$ | async"
                [ngStyle]="{ 'color': color !== 'white' && !isStroked ? 'white' : '' }"
        >
            <div class="center-center">
                <ng-content></ng-content>
            </div>
        </button>
    }

    <!-- The popup only appears when a popup is set and the button is disabled -->
    @if (popup && (disabled$ | async)) {
        <cb-popup-tip [popup]="popup" (popupClick)="onPopupClick($event)"></cb-popup-tip>
    }
</div>

@if (icon && !isMenuItem && !buttonLabel) {
    <button
        mat-icon-button
        [color]="color"
        (click)="onClick($event)"
        [disabled]="disabled$ | async">
        <mat-icon [color]="getIconColor()"
                  [ngClass]="getIconClass()">{{ icon }}
        </mat-icon>
    </button>
}
@if (icon && buttonLabel) {
    <button
        mat-button
        [color]="color"
        (click)="onClick($event)"
        [disabled]="disabled$ | async"
        [ngClass]="isStroked ? 'mat-stroked-button' : 'mat-raised-button'">
        <mat-icon [color]="getIconColor()"
                  [ngClass]="getIconClass()">{{ icon }}
        </mat-icon>
        {{ buttonLabel }}
    </button>
}
@if (menu && !menuButtonLabel) {
    <button
        [matMenuTriggerFor]="menu"
        mat-icon-button
        (click)="onClick($event)"
        [disabled]="disabled$ | async">
        <mat-icon [color]="getIconColor()"
                  [ngClass]="getIconClass()">more_horiz
        </mat-icon>
    </button>
}
@if (menu && menuButtonLabel) {
    <button
        [matMenuTriggerFor]="menu"
        mat-raised-button
        (click)="onClick($event)"
        [disabled]="disabled$ | async">
        <mat-icon [color]="getIconColor()"
                  [ngClass]="getIconClass()">arrow_drop_down
        </mat-icon>
        {{ menuButtonLabel }}
    </button>
}
@if (isMenuItem) {
    <button
        mat-menu-item
        [disabled]="disabled$ | async"
        (click)="onClick($event)">
        <mat-icon [color]="getIconColor()"
                  [ngClass]="getIconClass()">{{ icon }}
        </mat-icon>
        {{ menuItemLabel }}
    </button>
}
